export const CHANGE_STYLE_PROPERTY = 'CHANGE_STYLE_PROPERTY';

export const SET_CURRENT_SCHEMA_NAME = 'SET_CURRENT_SCHEMA_NAME';

export const SAVE_STORE_STYLES_START = 'SAVE_STORE_STYLES_START';
export const SAVE_STORE_STYLES_SUCCESS = 'SAVE_STORE_STYLES_SUCCESS';
export const SAVE_STORE_STYLES_FAILED = 'SAVE_STORE_STYLES_FAILED';

export const GET_CURRENT_STORE_STYLES_START = 'GET_CURRENT_STORE_STYLES_START';
export const GET_CURRENT_STORE_STYLES_SUCCESS = 'GET_CURRENT_STORE_STYLES_SUCCESS';
export const GET_CURRENT_STORE_STYLES_FAILED = 'GET_CURRENT_STORE_STYLES_FAILED';

export const GET_DEFAULT_STORE_STYLES_START = 'GET_DEFAULT_STORE_STYLES_START';
export const GET_DEFAULT_STORE_STYLES_SUCCESS = 'GET_DEFAULT_STORE_STYLES_SUCCESS';
export const GET_DEFAULT_STORE_STYLES_FAILED = 'GET_DEFAULT_STORE_STYLES_FAILED';


export const updateStylePalette = (palette) => ({
  type: CHANGE_STYLE_PROPERTY,
  palette
});

export const setCurrentColorSchemaName = (schemaName) => ({
  type: SET_CURRENT_SCHEMA_NAME,
  schemaName
});

export const saveStoreStylesStart = () => ({
  type: SAVE_STORE_STYLES_START,
});

export const saveStoreStylesSuccess = (data, isSaveAsDefault) => ({
  type: SAVE_STORE_STYLES_SUCCESS,
  data,
  isSaveAsDefault
});

export const saveStoreStylesFailed = (error) => ({
  type: SAVE_STORE_STYLES_FAILED,
  error
});

export const getCurrentStoreStylesStart = () => ({
  type: GET_CURRENT_STORE_STYLES_START,
});

export const getCurrentStoreStylesSuccess = (data) => ({
  type: GET_CURRENT_STORE_STYLES_SUCCESS,
  data
});

export const getCurrentStoreStylesFailed = (error) => ({
  type: GET_CURRENT_STORE_STYLES_FAILED,
  error
});

export const getDefaultStoreStylesStart = () => ({
  type: GET_DEFAULT_STORE_STYLES_START,
});

export const getDefaultStoreStylesSuccess = (data) => ({
  type: GET_DEFAULT_STORE_STYLES_SUCCESS,
  data
});

export const getDefaultStoreStylesFailed = (error) => ({
  type: GET_DEFAULT_STORE_STYLES_FAILED,
  error
});
